import { organizationApi } from "@/core/data/api";

export default async () => {
  return await organizationApi.getOrganizationList({ active: true });
};
